<template>
  <Chart :chartData="computedData" :options="computedOptions" />
</template>

<script>
  import ChartMetrics from '@/mixins/ChartMetrics'
  import merge from 'lodash/merge'

  export default {
    name: 'ChartCPU',
    mixins: [
      ChartMetrics,
    ],
    computed: {
      computedData() {
        return {
          datasets: [{
            label: 'Usage',
            borderWidth: 0,
            borderColor: '#6699ff',
            backgroundColor: '#6699ff',
            pointRadius: 0,
            fill: true,
            spanGaps: false,
            data: this.data ? this.data[0]: [],
          }]
        }
      },
      computedOptions() {
        return merge(this.options, {
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                suggestedMax: 100,
                maxTicksLimit: 10,
                callback(value) {
                  return `${value}%`
                },
              },
            }],
          },
          tooltips: {
            callbacks: {
              label(tooltipItem) {
                const value = +tooltipItem.value
                return `Usage: ${value.toFixed(value < 1 ? 2 : (value < 10 ? 1 : 0))}%`
              }
            }
          },
        })
      },
    },
  }
</script>
